import React from "react";

const PlusIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.218"
      height="13.218"
      viewBox="0 0 13.218 13.218"
    >
      <path
        id="add_ic_2"
        d="M30.771,24.162H25.514V18.905a.676.676,0,1,0-1.352,0v5.257H18.905a.676.676,0,1,0,0,1.352h5.257v5.257a.676.676,0,0,0,1.352,0V25.514h5.257a.676.676,0,0,0,0-1.352Z"
        transform="translate(-18.229 -18.229)"
        fill={fill ? fill : "#0051bc"}
      />
    </svg>
  );
};

export default PlusIcon;
